import React, { Component } from "react";
import IntegrationReactSelect from "../../forms/autoCompleteInput";
import Paper from "@material-ui/core/Paper";
import { Input } from "../../forms/input";
import Signbutton, { Debtbutton } from "../../forms/button";
import { connect } from "react-redux";
import { getNewPurchaseFundList } from "../../../store/actions";
import { EKYCMail } from "../../../store/actions/investors";
import CustomizedSelect from "./customizedSelect";
import MenuItem from "@material-ui/core/MenuItem";
import {
  GET_FUNDS_LIST,
  GET_FUNDS_LIST_SUCCESS,
  GET_FUNDS_LIST_FAILED,
  ALL,
} from "../../../store/types";
import { KycNotDoneDialog } from "../customModal";
import InputBase from "@material-ui/core/InputBase";
class EKYC extends Component {
  constructor(props) {
    super(props);
    const { match } = this.props;
    this.state = {
      kycType: { value: "" },
      ipv: { value: "YES", errorMessage: "" },
      messageAlert: "",
      open: false,
      pan: {
        value:
          !!match && !!match.params && !!match.params.pan
            ? match.params.pan
            : "",
      },
      fund: { value: "" },
      name: { value: "" },
      email: { value: "" },
      mobile: { value: "" },
      code: { value: "+91" },
    };
  }

  async componentDidMount() {
    const params = {
      opt: ALL,
      schemetype: this.props.userId,
    };
    const types = [
      GET_FUNDS_LIST,
      GET_FUNDS_LIST_SUCCESS,
      GET_FUNDS_LIST_FAILED,
    ];
    this.props.getNewPurchaseFundList(params, types);
  }

  handleChange = (value) => {
    this.setState({
      fund: { value },
      pan: { value: this.state.pan.value },
    });
  };

  changeValue = (label) => (event) => {
    if (label === "pan" && event.target.value.length < 11) {
      this.setState({
        [label]: { value: event.target.value },
      });
    } else if (label != "pan") {
      this.setState({
        [label]: { value: event.target.value },
      });
    } else if (label === "code") {
      const value = event.target.value;
      if (!value) {
        this.setState({
          [label]: {
            value: "",
            isError: true,
            errorMessage: "Country Code is Mandatory",
          },
        });
      } else if (!/^[+]\d{1,3}$/.test(value)) {
        this.setState({
          [label]: {
            value: "",
            isError: true,
            errorMessage: "Enter a Valid Country Code",
          },
        });
      } else {
        this.setState({
          [label]: { value },
        });
      }
    }
  };

  changeIpvValue = (value) => () => {
    if (value === "YES") {
      this.setState({
        ipv: { value: "YES" },
      });
    } else if (value === "NO") {
      this.setState({
        ipv: {
          value: "NO",
          errorMessage: "(It is mandatory to perform IPV to proceed )",
        },
      });
    }
  };
  submit = async () => {
    const { ipv, open, messageAlert, code, email, ...others } = this.state;
    const keys = Object.keys(others);
    const findError = keys.every((key) => !!others[key].value);
    if (!this.state.mobile.value) {
      this.setState({
        mobile: {
          value: "",
          isError: true,
          errorMessage: "Enter a valid phone number",
        },
      });
      return;
    } else if (
      !/^[6-9]\d{9}$/.test(this.state.mobile.value) &&
      this.state.code.value === "+91"
    ) {
      this.setState({
        mobile: {
          value: "",
          isError: true,
          errorMessage: "Enter a valid phone number",
        },
      });
      return;
    }
    if (!code.value) {
      this.setState({
        code: {
          value: this.state.code.value,
          isError: true,
          errorMessage: "Country Code is Mandatory",
        },
      });
      return;
    }
    if (!/^[+]\d{1,3}$/.test(code.value)) {
      this.setState({
        code: {
          value: this.state.code.value,
          isError: true,
          errorMessage: "Enter a Valid Country Code",
        },
      });
      return;
    }
    if (!findError) {
      keys.forEach((key) => {
        !others[key].value &&
          this.setState({
            [key]: {
              ...others[key],
              isError: true,
              errorMessage: `${
                key === "kycType"
                  ? "KYC type"
                  : key === "fund"
                  ? "Fund"
                  : key === "pan"
                  ? "PAN"
                  : key === "name"
                  ? "Name"
                  : key === "email"
                  ? "Email"
                  : key === "mobile"
                  ? "Mobile"
                  : key
              } is mandatory`,
            },
          });
      });
      return;
    } else if (
      !/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/.test(this.state.pan.value)
    ) {
      this.setState({
        pan: {
          value: "",
          isError: true,
          errorMessage: "please enter a valid pan",
        },
      });
    } else if (this.state.name.value === "") {
      this.setState({
        name: {
          isError: true,
          errorMessage: "(Name is Mandatory)",
        },
      });
    } else if (
      !!this.state.email.value &&
      /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
        this.state.email.value
      ) === false
    ) {
      this.setState({
        email: {
          ...others["email"],
          isError: true,
          errorMessage: `Enter a vaild Email address`,
        },
      });
      return;
    } else if (
      this.state.ipv.value === "NO" &&
      this.state.kycType.value === "DKYC"
    ) {
      this.setState({
        ipv: {
          value: "NO",
          // isError: true,
          errorMessage: "(It is mandatory to perform IPV to proceed )",
        },
      });
    } else {
      if (this.state.kycType.value === "IKYC") {
        const { fund, name, email, mobile, pan } = this.state;
        const url = `https://mfs.kfintech.com/ckyc/eKyc.aspx?UserID=2703&AgencyCode=${fund.value.value}&AgencyTransactionID=123&Pan=${pan.value}&PanName=${name.value}&Mobile=${mobile.value}&EmailID=${email.value}&AuthType=3&ipv=y&EmpName=${this.props.userId}&EmpDesig=Manager&EmpCode=${this.props.token}&EmpLoc=Hyderabad&FundCode=${fund.value.value}&fromType=DITWEB`;

        const params = {
          InvPan: this.state.pan.value,
          countrycode: this.state.code.value,
          InvMobile: mobile.value,
          InvFund: fund.value.value,
          InvName: name.value,
          DistUserId: this.props.userId,
          Url: url,
          DistName:this.props.userId,
          ArnCode: this.props.token,
          InvEmail:email.value,
        };
       

        const response = await this.props.EKYCMail(params);
        if (response && !response.error) {
          this.setState({
            open: true,
            messageAlert:
              "An email will be triggered to investor's email for uploading neccesary KYC documents and selfie video.please confirm",
          });
        }
      } else {
        const { fund, email, mobile, name } = this.state;
        window.open(
          `https://mfs.kfintech.com/ckyc/eKyc.aspx?UserID=2703&AgencyCode=${fund.value.value}&AgencyTransactionID=123&Pan=${this.state.pan.value}&PanName=${name.value}&Mobile=${mobile.value}&EmailID=${email.value}&AuthType=3&ipv=y&EmpName=${this.props.userId}&EmpDesig=Manager&EmpCode=${this.props.token}&EmpLoc=Hyderabad&FundCode=${fund.value.value}&fromType=DITWEB`,
          "_self"
        );
      }
    }
  };

  closeModal = () => {
    this.setState({
      open: false,
      messageAlert: "",
    });
  };

  continue = () => {
    const { params } = this.props.match;
    this.setState({
      kycType: { value: "" },
      ipv: { value: "YES", errorMessage: "" },
      fund: { value: "" },
      pan: { value: !!params && !!params.pan ? params.pan : "" },
      open: false,
      messageAlert: "",
      name: { value: "" },
      email: { value: "" },
      mobile: { value: "" },
    });
  };

  handleChangeKycType = (event) => {
    const { match } = this.props;
    this.setState({
      kycType: { value: event.target.value },
      ipv: { value: "YES", errorMessage: "" },
      fund: { value: "" },
      pan: {
        value:
          !!match && !!match.params && !!match.params.pan
            ? match.params.pan
            : "",
      },
      name: { value: "" },
      email: { value: "" },
      mobile: { value: "" },
    });
  };
  render() {
    const { fundsList } = this.props;
    const { fund, email, name, mobile, kycType } = this.state;
    return (
      <div className="container-margin">
        <div className="investor-title">e-KYC Form</div>

        <Paper
          className="digital-form-container"
          style={{ boxShadow: "0px 0px 2px 0px lightgray" }}
        >
          <div
            className="digital-form-Right-div"
            style={{ marginTop: 50, borderLeft: 0 }}
          >
            <div className="transaction-details">
              <div className="input-margin flex">
                <div className="appbar-div dual-margin input-name-responsive">
                  <CustomizedSelect
                    name="KYC Type"
                    // uptext={
                    //   this.state.kycType.value === "DKYC"
                    //     ? "Investor Presence Required *"
                    //     : ""
                    // }
                    handleChange={this.handleChangeKycType}
                    value={kycType.value}
                    isError={kycType.isError}
                    errorMessage={kycType.errorMessage}
                    isShowError={kycType.isError}
                    placeholder="Select KYC Type"
                  >
                    <MenuItem value="DKYC" key="DKYC" className="menuItem">
                      Distributor (e-KYC)
                    </MenuItem>
                    <MenuItem value="IKYC" key="IKYC">
                      Online IPV with Esign
                    </MenuItem>
                  </CustomizedSelect>
                  <div
                    style={{
                      fontSize: 14,
                      fontFamily: "OpenSans-SemiBold",
                      color: "red",
                    }}
                  >
                    {this.state.kycType.value === "IKYC"
                      ? ""
                      : this.state.kycType.value === "DKYC"
                      ? "Investor Presence Required *"
                      : ""}
                  </div>
                </div>
                <div
                  className="appbar-div dual-margin input-name-responsive"
                  style={{ marginTop: -15 }}
                >
                  <div className="input-name input-name-sizing-responsive">
                    AMC
                  </div>
                  <IntegrationReactSelect
                    suggestions={fundsList.map((item) => ({
                      label: item.amc_name,
                      value: item.amc_code,
                    }))}
                    value={fund.value}
                    label="AMC"
                    placeholder="Select AMC"
                    handleChange={this.handleChange}
                    inputref={(ele) => (this.fundField = ele)}
                    isError={fund.isError}
                    errorMessage={fund.errorMessage}
                  />
                </div>
              </div>
              <div className="input-margin flex">
                <div className="appbar-div dual-margin input-name-responsive ">
                  <div className="input-name">PAN</div>
                  <div style={{ marginTop: 10 }}>
                    <Input
                      name=""
                      onChange={this.changeValue("pan")}
                      value={this.state.pan.value}
                      isShowError={this.state.pan.isError}
                      errorMessage={this.state.pan.errorMessage}
                      disable={
                        !!this.props.match &&
                        !!this.props.match.params &&
                        !!this.props.match.params.pan
                          ? true
                          : false
                      }
                    />
                  </div>
                </div>
                <div className="appbar-div dual-margin input-name-responsive">
                  <div className="input-name">Name</div>
                  <div style={{ marginTop: 10 }}>
                    <Input
                      name=""
                      onChange={this.changeValue("name")}
                      value={name.value}
                      isShowError={name.isError}
                      errorMessage={name.errorMessage}
                    />
                  </div>
                </div>
              </div>
              <div className="input-margin flex">
                <div className="appbar-div dual-margin input-name-responsive">
                  <Input
                    name="Email ID"
                    onChange={this.changeValue("email")}
                    value={email.value}
                    isShowError={email.isError}
                    errorMessage={email.errorMessage}
                  />
                </div>
              </div>
              <div className="input-margin flex">
                {" "}
                <div className="appbar-div dual-margin input-name-responsive">
                  <Input
                    name="Country Code"
                    value={this.state.code.value}
                    onKeyDown={(evt) => {
                      if (
                        evt.key === "e" ||
                        evt.key === "." ||
                        evt.key === "-"
                      ) {
                        evt.preventDefault();
                      }
                    }}
                    onChange={this.changeValue("code")}
                    isError={this.state.code.isError}
                    isShowError={this.state.code.isError}
                    errorMessage={this.state.code.errorMessage}
                    inputref={(ele) => (this.countryCodeField = ele)}
                  />
                </div>
                <div className="appbar-div dual-margin input-name-responsive">
                  <Input
                    name="Mobile No."
                    onChange={this.changeValue("mobile")}
                    value={mobile.value}
                    isShowError={mobile.isError}
                    errorMessage={mobile.errorMessage}
                  />
                </div>
              </div>{" "}
              {/* <div className="appbar-div dual-margin input-name-responsive">
              <Input
                name="Mobile No."
                onChange={this.changeValue("mobile")}
                value={mobile.value}
                isShowError={mobile.isError}
                errorMessage={mobile.errorMessage}
              />
            </div> */}
              {this.state.kycType.value === "IKYC" && (
                <div className="instructions-box">
                  <div className="instruction-title">Instructions Box</div>
                  <ul>
                    <li className="instruction-mode">
                      This process will send an Email to your client for
                      completing the KYC process
                    </li>
                    <li className="instruction-mode">
                      Your client has to upload relevant documents and record a
                      video of self by showing the documents.{" "}
                    </li>
                    <li className="instruction-mode">
                      Please inform and guide your client accordingly.
                    </li>
                  </ul>
                </div>
              )}
              {this.state.kycType.value === "DKYC" && (
                <div className="input-margin flex">
                  {/* <div className="appbar-div dual-margin ">
                    <div
                      style={{ fontSize: 15, fontFamily: "OpenSans-SemiBold" }}
                    >
                      Do you perform In Person Verification(IPV) ?
                    </div>
                    <div className="radio-buttons-div">
                      <div style={{ margin: "15px 0px" }}>
                        <Debtbutton
                          buttontitle="YES"
                          width={120}
                          active={this.state.ipv.value === "YES"}
                          onClick={this.changeIpvValue("YES")}
                        />
                      </div>
                      <div style={{ margin: "15px 0px" }}>
                        <Debtbutton
                          buttontitle="NO"
                          width={120}
                          active={this.state.ipv.value === "NO"}
                          onClick={this.changeIpvValue("NO")}
                        />
                        {!!this.state.ipv.errorMessage && (
                          <div
                            style={{
                              color: "red",
                              fontSize: 12,
                              fontFamily: "OpenSans-Italic",
                            }}
                          >
                            {" "}
                            {this.state.ipv.errorMessage}
                          </div>
                        )}
                      </div>
                    </div>
                  </div> */}

                  <div className="appbar-div dual-margin">
                    <div
                      style={{ fontSize: 15, fontFamily: "OpenSans-SemiBold" }}
                    >
                      Required Documents
                    </div>
                    <ul
                      className="redemption-details"
                      style={{
                        color: "#0076cb",
                        backgroundColor: "#f4f4f4",
                        fontFamily: "OpenSans-SemiBold",
                        lineHeight: 5,
                      }}
                    >
                      <li>Aadhaar XML or PDF File</li>
                      <li>Share code</li>
                    </ul>
                  </div>
                  <div className="appbar-div dual-margin"> </div>
                </div>
              )}
              {/* {this.state.kycType.value === "DKYC" && (
                <div className="input-margin flex">
                  <div className="appbar-div dual-margin ">
                    <div
                      style={{ fontSize: 15, fontFamily: "OpenSans-SemiBold" }}
                    >
                      Do you want to submit the documents?
                    </div>
                    <div className="radio-buttons-div">
                      <div style={{ margin: "15px 0px" }}>
                        <Debtbutton
                          buttontitle="YES"
                          width={120}
                          active={"YES"}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="appbar-div dual-margin "></div>
                </div>
              )} */}
              {this.state.kycType.value === "DKYC" && (
                <div className="instructions-box">
                  <div className="instruction-title">Instructions Box</div>
                  <ul>
                    <li className="instruction-mode">
                      This process is based on e-Aadhaar, please keep the masked
                      e-Aadhaar copy and password ready before initiating.
                    </li>
                    <li className="instruction-mode">
                      First investment is allowed only towards the fund
                      selected.
                    </li>
                  </ul>
                </div>
              )}
              <div className="digital-form-button-next-div">
                <Signbutton buttontitle="Submit" onClick={this.submit} />
              </div>
              <KycNotDoneDialog
                message={this.state.messageAlert}
                open={this.state.open}
                continue={this.continue}
                close={this.closeModal}
              />
            </div>
          </div>
        </Paper>
      </div>
    );
  }
}

export default connect(
  ({ authReducer, transactions }) => {
    const { token, userId } = authReducer;
    const { fundsList = [] } = transactions;
    return {
      token,
      userId,
      fundsList,
    };
  },
  { getNewPurchaseFundList, EKYCMail }
)(EKYC);
